import React from "react";
import Box from "@mui/material/Box";
import FAQSection from "./FAQSection";
import EducationalVideoSection from "./EducationalVideoSection";
import { Typography } from "@mui/material";
import ArticleSection from "./ArticlesSection";
import WhatsNewSection from "./WhatsNewSection";
import type {
  ResourceArticle,
  ResourceFaq,
  ResourcePaginationHandler,
  ResourceTabLabel,
  ResourceVideo,
  ResourceWhatsNew,
} from "../types";

interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

interface AllSectionTabsProps {
  tabs: ResourceTabLabel[];
  value: number;
  faqData: ResourceFaq[];
  pageIndex: number;
  pageSize: number;
  handlePageChange: ResourcePaginationHandler;
  educationalVideos: ResourceVideo[];
  totalVideos: number;
  articles: ResourceArticle[];
  totalArticles: number;
  articlesPageIndex: number;
  articlesPageSize: number;
  handleArticlePageChange: ResourcePaginationHandler;
  whatsNew: ResourceWhatsNew[];
  totalNewData: number;
  newDataPageIndex: number;
  newDataPageSize: number;
  handleWhatsNewPage: ResourcePaginationHandler;
}

export default function AllSectionTabs({
  tabs,
  value,
  faqData,
  pageIndex,
  pageSize,
  handlePageChange,
  educationalVideos,
  totalVideos,
  articles,
  totalArticles,
  articlesPageIndex,
  articlesPageSize,
  handleArticlePageChange,
  whatsNew,
  totalNewData,
  newDataPageIndex,
  newDataPageSize,
  handleWhatsNewPage,
}: AllSectionTabsProps) {
  return (
    <div className="all-section">
      {tabs?.map((tab, i) => (
        <TabPanel value={value} index={i} key={i}>
          {(() => {
            switch (tab) {
              case "FAQ":
                return <FAQSection faq={faqData} />;
              case "Educational Videos":
                return (
                  <EducationalVideoSection
                    educationalVideos={educationalVideos}
                    handlePageChange={handlePageChange}
                    pageSize={pageSize}
                    pageIndex={pageIndex}
                    totalVideos={totalVideos}
                  />
                );
              case "Helpful Content":
                return (
                  <ArticleSection
                    articles={articles}
                    totalArticles={totalArticles}
                    articlesPageIndex={articlesPageIndex}
                    articlesPageSize={articlesPageSize}
                    handleArticlePageChange={handleArticlePageChange}
                  />
                );
              case "What's New":
                return (
                  <WhatsNewSection
                    whatsNew={whatsNew}
                    totalNewData={totalNewData}
                    newDataPageSize={newDataPageSize}
                    newDataPageIndex={newDataPageIndex}
                    handleWhatsNewPage={handleWhatsNewPage}
                  />
                );
              default:
                return null;
            }
          })()}
        </TabPanel>
      ))}
    </div>
  );
}
